// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".launcher {\n  margin-top: 6rem;\n  text-align: center;\n}\n.message {\n  text-align: center;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 1.15px;\n  margin-top: -7em;\n  font-weight: 700;\n}", ""]);
// Exports
module.exports = exports;
